import compact from "lodash/compact";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import map from "lodash/map";
import some from "lodash/some";
import locale from "./buildModelErrors.locale";
export default (data) => {
    const result = [];
    if (!data)
        return result;
    const documentObjectIds = new Set();
    const attrIds = {};
    forEach(data.DocumentObjects, obj => {
        documentObjectIds.add(obj.Id);
        attrIds[obj.Id] = new Set();
        if (!obj.Attributes) {
            result.push(locale.noDocumentObjectAttributes(obj.Id, obj.Name));
        }
        else {
            forEach(obj.Attributes, attr => {
                attrIds[obj.Id].add(attr.Id);
            });
        }
    });
    forEach(data.Transforms, obj => {
        var _a, _b;
        if (!obj.Input || !((_a = obj.Input.Types) === null || _a === void 0 ? void 0 : _a.length)) {
            result.push(locale.noTransformInputTypes(obj.Id, obj.Name));
        }
        else {
            const invalidInputTypes = filter(obj.Input.Types, t => !documentObjectIds.has(t));
            if (invalidInputTypes.length) {
                result.push(locale.invalidTransformInputTypes(obj.Id, obj.Name, invalidInputTypes));
            }
            const fieldsIds = compact(map(obj.Input.Fields, "Ids[0].Value"));
            const invalidInputFields = filter(fieldsIds, f => { var _a; return !some((_a = obj.Input) === null || _a === void 0 ? void 0 : _a.Types, t => attrIds[t] && attrIds[t].has(f)); });
            if (invalidInputFields.length) {
                result.push(locale.invalidTransformInputFields(obj.Id, obj.Name, invalidInputFields));
            }
        }
        if (!((_b = obj.Output) === null || _b === void 0 ? void 0 : _b.length)) {
            result.push(locale.noTransformOutputTypes(obj.Id, obj.Name));
        }
        else {
            const invalidOutputTypes = filter(obj.Output, t => !documentObjectIds.has(t));
            if (invalidOutputTypes.length) {
                result.push(locale.invalidTransformOutputTypes(obj.Id, obj.Name, invalidOutputTypes));
            }
        }
    });
    return result;
};
